/* eslint-disable react/prop-types */
import React from 'react';

interface IconProps {
  IconClass?: string;
  color?: 'white' | 'blue';
}

export const CloudArrowUpIcon: React.FC<IconProps> = ({ IconClass, color }) => {
  if (color === 'white')
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 4.5C9.58676 4.5 7.61684 6.39994 7.50502 8.78512C7.48627 9.18524 7.15641 9.5 6.75585 9.5H6.5C4.84315 9.5 3.5 10.8431 3.5 12.5C3.5 14.1569 4.84315 15.5 6.5 15.5H10.0764C10.0261 15.826 10 16.1599 10 16.5C10 16.6682 10.0064 16.835 10.0189 17H6.5C4.01472 17 2 14.9853 2 12.5C2 10.1564 3.79155 8.23125 6.07981 8.01936C6.54808 5.17188 9.02022 3 12 3C14.9798 3 17.4519 5.17189 17.9202 8.01936C20.2085 8.23125 22 10.1564 22 12.5C22 12.6664 21.991 12.8307 21.9734 12.9925C21.5031 12.2601 20.8898 11.6283 20.1729 11.1365C19.6764 10.165 18.6659 9.5 17.5 9.5H17.2442C16.8436 9.5 16.5137 9.18524 16.495 8.78512C16.3832 6.39994 14.4132 4.5 12 4.5ZM22 16.5C22 19.5376 19.5376 22 16.5 22C13.4624 22 11 19.5376 11 16.5C11 13.4624 13.4624 11 16.5 11C19.5376 11 22 13.4624 22 16.5ZM16 19.5C16 19.7761 16.2239 20 16.5 20C16.7761 20 17 19.7761 17 19.5V14.7071L18.6464 16.3536C18.8417 16.5488 19.1583 16.5488 19.3536 16.3536C19.5488 16.1583 19.5488 15.8417 19.3536 15.6464L16.8536 13.1464C16.6583 12.9512 16.3417 12.9512 16.1464 13.1464L13.6464 15.6464C13.4512 15.8417 13.4512 16.1583 13.6464 16.3536C13.8417 16.5488 14.1583 16.5488 14.3536 16.3536L16 14.7071V19.5Z"
          fill="white"
        />
      </svg>
    );

  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={IconClass}
    >
      <path
        d="M12.5 4.5C10.0868 4.5 8.11684 6.39994 8.00502 8.78512C7.98627 9.18524 7.65641 9.5 7.25585 9.5H7C5.34315 9.5 4 10.8431 4 12.5C4 14.1569 5.34315 15.5 7 15.5H10.5764C10.5261 15.826 10.5 16.1599 10.5 16.5C10.5 16.6682 10.5064 16.835 10.5189 17H7C4.51472 17 2.5 14.9853 2.5 12.5C2.5 10.1564 4.29155 8.23125 6.57981 8.01936C7.04808 5.17188 9.52022 3 12.5 3C15.4798 3 17.9519 5.17189 18.4202 8.01936C20.7085 8.23125 22.5 10.1564 22.5 12.5C22.5 12.6664 22.491 12.8307 22.4734 12.9925C22.0031 12.2601 21.3898 11.6283 20.6729 11.1365C20.1764 10.165 19.1659 9.5 18 9.5H17.7442C17.3436 9.5 17.0137 9.18524 16.995 8.78512C16.8832 6.39994 14.9132 4.5 12.5 4.5ZM22.5 16.5C22.5 19.5376 20.0376 22 17 22C13.9624 22 11.5 19.5376 11.5 16.5C11.5 13.4624 13.9624 11 17 11C20.0376 11 22.5 13.4624 22.5 16.5ZM16.5 19.5C16.5 19.7761 16.7239 20 17 20C17.2761 20 17.5 19.7761 17.5 19.5V14.7071L19.1464 16.3536C19.3417 16.5488 19.6583 16.5488 19.8536 16.3536C20.0488 16.1583 20.0488 15.8417 19.8536 15.6464L17.3536 13.1464C17.1583 12.9512 16.8417 12.9512 16.6464 13.1464L14.1464 15.6464C13.9512 15.8417 13.9512 16.1583 14.1464 16.3536C14.3417 16.5488 14.6583 16.5488 14.8536 16.3536L16.5 14.7071V19.5Z"
        fill="#2277DB"
      />
    </svg>
  );
};

export default CloudArrowUpIcon;
